import { useEffect, useState } from 'react'
import { environment } from '../../environments/environment'
// import sponsors from './useSponsorsData.json'

interface Sponsor {
    name: string
    title: string
    image?: string
    description?: string
    link: string
    startDate?: string
    endDate?: string
}

export function useSponsors() {
    const [loading, setLoading] = useState(true)
    const [sponsors, setSponsors] = useState<Sponsor[] | undefined>(undefined)

    const today = new Date().toISOString().substring(0, 10) // e.g. '2021-02-09'

    useEffect(() => {
        getSponsors()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function getSponsors() {
        fetch(`${environment.assetBaseUrl}/public-assets/sponsors-data.json`, {
            method: 'GET',
        })
            .then(async (resp) => {
                setLoading(false)
                if (resp.status !== 200) {
                    console.error('Error retrieving sponsor data', resp)
                } else {
                    const fetchedResp: any = await resp.json()
                    const groomedData = fetchedResp
                        .filter(isWithinEndDate(today))
                        .map((s: any) => {
                            // Explicitly assign values here as we can't guarantee the shape of the response
                            return {
                                name: s.name,
                                title: s.title,
                                description: s.description,
                                link: s.link,
                                startDate: s.startDate,
                                endDate: s.endDate,
                                image: `${environment.assetBaseUrl}/public-assets/sponsor-image-${s.id}.png`,
                            }
                        })
                    setSponsors(groomedData)
                }
            })
            .catch((error) => {
                setLoading(false)
                console.error('Error retrieving sponsor data', error)
            })
    }

    return { loading, sponsors }
}

export function isWithinEndDate(today: string) {
    return (sponsor: Sponsor) => {
        // no start/end dates, so it's always valid
        if (!sponsor.startDate && !sponsor.endDate) {
            return true
        }

        if (sponsor.startDate && today < sponsor.startDate) {
            return false
        }

        if (sponsor.endDate && today > sponsor.endDate) {
            return false
        }

        return true
    }
}
